// Module
var code = "<script>let $ctrl</script> <molecule-panel-edit-row-readonly ng-if=\"$ctrl.factsheetExists\"> <row-label> <atom-text>{{ $ctrl.productFactsheetTitle }}</atom-text> </row-label> <row-value> <atom-text>{{ $ctrl.productFactsheetValue }}</atom-text> </row-value> </molecule-panel-edit-row-readonly> ";
// Exports
module.exports = code;